import React from 'react';
import { formatWorkOutput } from '../../utils/engineStub';
import './MetricBadge.css';

export default function MetricBadge({ value, label = 'Work Output', size = 'md', grade }) {
  return (
    <div className={`metric-badge metric-badge--${size} ${grade ? `metric-badge--${grade}` : ''}`}>
      <span className="metric-badge__value">{formatWorkOutput(value)}</span>
      <span className="metric-badge__label">{label}</span>
    </div>
  );
}
